import React, { Component } from "react";
import { Link } from "react-router";

import Logo from "./logo_white.png";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="aboss__header">
        <div className="aboss__header-container">
          <div className="aboss__header-logo">
            <div className="aboss__header-logo-colors"></div>
            <Link to="/">
              <img
                alt="ABOSS Logo"
                src={Logo}
                className="aboss__header-content-logo-black"
              />
            </Link>
          </div>

          <ul>
            {/* <li>
              Products
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              <div className="aboss__header-products">
                <ul>
                  <li className="aboss__header-products-artist">
                    <Link to="/products/artist">
                      <h1>Artist</h1>
                      <h2>For artist & team</h2>
                      <p>
                        Organize your data, streamline your backoffice and
                        collaborate with your team
                      </p>
                    </Link>
                  </li>
                  <li className="aboss__header-products-agency">
                    <Link to="/products/agency">
                      <h1>Agency</h1>
                      <h2>For Agents & Managers</h2>
                      <p>
                        Manage multiple calendars, structure your backoffice and
                        gain insight in data to optimize business strategies
                      </p>
                    </Link>
                  </li>
                </ul>
              </div>
            </li> */}
            {/* <li>
              <Link to="/pricing">Pricing</Link>
            </li> */}
            <li>
              <a href="https://help.a-boss.net" target="_abosshelp">
                Support
              </a>
            </li>
            <li>
              Sign In
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              <div>
                <ul>
                  <li>
                    <a href="https://artist.a-boss.net" target="_abossartist">
                      ABOSS Artist
                    </a>
                  </li>
                  <li>
                    <a href="https://agency.a-boss.net" target="_abossagency">
                      ABOSS Agency
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a href="https://abossmusic.com/artist/trial">
                <button>Sign up</button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/header/index.js